import GlobalVariables from '../GlobalVariables';

const RebasePath = (filePath) => {
    let path = filePath;
    if (path.startsWith('http')) {
        return `url(${path})`;
    }
    if (path.startsWith('/')) {
        path = path.substring(1);
    }
    if (env.IsCDN === 'true') {
        return `url(${GlobalVariables.CdnBaseUrl}${path})`;
    }
    return `url(${GlobalVariables.ApexChatBaseUrl}${path})`;
};
export default RebasePath;
